module.exports = __webpack_public_path__ + "images/send-mail.png";